<template>
    <v-card outlined style="overflow: hidden; max-height: inherit">
        <v-card-text style="overflow-y: auto; max-height: inherit" ref="list">
            <v-row class="ma-n1">
                <template v-for="(message, index) in messages">
                    <messages-item v-bind="{ index, message, isScrollFixed }" v-on="{ scroll }" :key="index" />
                </template>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import MessagesItem from "./messages/messages-item.vue";

export default {
    components: {
        MessagesItem,
    },
    props: {
        messages: { type: Array, default: () => [] },
    },
    data: () => ({
        isInitiated: false,
        isScrollFixed: true,
    }),
    methods: {
        init() {
            if (!this.isInitiated) {
                const intervalId = setInterval(() => {
                    const el = this.$refs["list"]?.$el;
                    if (!el) return;

                    el.addEventListener("scroll", this.onScroll);
                    el.scrollTop = el.scrollHeight;
                    this.isInitiated = true;

                    clearInterval(intervalId);
                }, 10);
            }
        },
        onScroll(event) {
            const { scrollHeight, scrollTop, clientHeight } = event.target;
            this.isScrollFixed = scrollHeight - (scrollTop + clientHeight) < 30;
        },
        scroll() {
            const el = this.$refs["list"];
            if (!el) return;
            el.scrollTo({ top: el.scrollHeight });
        },
    },
    watch: {
        isInitiated() {
            this.$nextTick(this.scroll);
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style>
</style>